// import React, { useState } from "react";
import "../../styles/TagEditorPage.css";
import useAccess from "../../hooks/useAccess";

const EditTagsTab = ({
  allTags,
  tagCategories,
  setTagCategories,
  categoryList,
  editedNames,
  setEditedNames,
  newTag,
  setNewTag,
  pendingNewTags,
  setPendingNewTags,
  pendingDeletes,
  setPendingDeletes,
  editTagId,
  setEditTagId,
}) => {
  const handleCategoryChange = (id, category) => {
    setTagCategories({ ...tagCategories, [id]: category });
  };

  const handleNameChange = (id, value) => {
    setEditedNames({ ...editedNames, [id]: value });
  };

  const handleAddNewTag = () => {
    if (!newTag.trim()) return;
    const tempId = Date.now(); // local only
    setPendingNewTags([...pendingNewTags, { t_id: tempId, t_name: newTag }]);
    setEditedNames({ ...editedNames, [tempId]: newTag });
    setTagCategories({ ...tagCategories, [tempId]: "" });
    setNewTag("");
  };

  const handleDeleteTag = (id) => {
    setPendingDeletes((prev) => [...prev, id]);
  };

  const filteredAllTags = allTags.filter(
    (tag) => !pendingDeletes.includes(tag.t_id)
  );
  const filteredNewTags = pendingNewTags.filter(
    (tag) => !pendingDeletes.includes(tag.t_id)
  );
  const allDisplayedTags = [...filteredAllTags, ...filteredNewTags];

  const { hasPermission } = useAccess();

  // ⭐ NEW: Centralized PERMISSION Map
  const PERMISSIONS = {
    tags: {
      create: hasPermission("AccountSetting", "Tags", "edit"),
      edit: hasPermission("AccountSetting", "Tags", "edit"),
      delete: hasPermission("AccountSetting", "Tags", "delete"),
    },
  };

  return (
    <div className="tag-editor-split">
      {/* LEFT SECTION */}
      <div className="tag-section-left">
        <label>
          <strong>Add New Tag</strong>
        </label>
        <div className="add-tag-input-group">
          <input
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            placeholder="Enter A New Tag Name Here"
            disabled={!PERMISSIONS.tags.create}
          />

          <button
            onClick={handleAddNewTag}
            className="btn btn-light"
            disabled={!PERMISSIONS.tags.create}
          >
            Add
          </button>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="tag-section-right">
        <label>
          <strong>Existing Tags</strong>
        </label>
        {allDisplayedTags.map((tag) => (
          <div key={tag.t_id} className="tag-row">
            <div className="tag-name">
              {editTagId === tag.t_id ? (
                <input
                  value={
                    editedNames[tag.t_id] !== undefined
                      ? editedNames[tag.t_id]
                      : tag.t_name
                  }
                  onChange={(e) => handleNameChange(tag.t_id, e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Escape") setEditTagId(null);
                  }}
                  autoFocus
                />
              ) : editedNames[tag.t_id] !== undefined ? (
                editedNames[tag.t_id]
              ) : (
                tag.t_name
              )}
            </div>

            <select
              className="tag-value-input"
              value={tagCategories[tag.t_id] || ""}
              onChange={(e) => handleCategoryChange(tag.t_id, e.target.value)}
              disabled={!PERMISSIONS.tags.edit}
            >
              <option value="">Select a category...</option>
              {categoryList.map((cat) => (
                <option key={cat.tc_id} value={cat.tc_id}>
                  {cat.tc_name}
                </option>
              ))}
            </select>

            {PERMISSIONS.tags.edit && (
              <div className="action-buttons">
                {editTagId === tag.t_id ? (
                  <button
                    className="icon-btn"
                    onClick={() => setEditTagId(null)}
                    title="Done"
                  >
                    ✅
                  </button>
                ) : (
                  <button
                    className="icon-btn"
                    onClick={() => {
                      setEditTagId(tag.t_id);
                      setEditedNames({
                        ...editedNames,
                        [tag.t_id]: tag.t_name,
                      });
                    }}
                    title="Edit"
                  >
                    <i className="fas fa-pen" />
                  </button>
                )}
                {PERMISSIONS.tags.delete && (
                  <button
                    className="icon-btn danger"
                    onClick={() => handleDeleteTag(tag.t_id)}
                    title="Delete"
                  >
                    <i className="fas fa-trash" />
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditTagsTab;
